const message = (instance) => {
    if (instance.type === 'checkbox') {
        return 'Please select one or more options';
    }
    else {
        return 'Please select an option';
    }
};
export const choiceButtonRequiredValidator = {
    /** The validator should be run when the required or type attributes change */
    attribute: ['required', 'type'],
    /** The message callback for the validator */
    message,
    /** Key off the valueMissing property of the global ValidityState interface */
    key: 'valueMissing',
    /** The valid callback for the validator */
    isValid(instance) {
        const root = instance.getRootNode?.();
        if (!root) {
            return true;
        }
        /**
         * For checkbox-type controls, the required property denotes that
         * any individual control _must_ be checked; otherwise, the control
         * is invalid, so return false.
         *
         * For radio-type checkboxes, only one item needs to be selected if
         * any elements are required.
         */
        if (instance.type === 'checkbox' && instance.required && !instance.selected) {
            return false;
        }
        else if (instance.type === 'radio') {
            const root = instance.getRootNode();
            const { localName, name } = instance;
            const requiredControls = Array.from(root.querySelectorAll(`${localName}[name="${name}"][required]`));
            if (requiredControls.length) {
                return requiredControls.some((control) => control.selected);
            }
        }
        return true;
    }
};
//# sourceMappingURL=choiceButtonRequiredValidator.js.map